// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"363":"e2c68d04","474":"1ef75c3c"}[chunkId] + ".chunk.css";
};